import { computed } from 'mobx';

export default class Invitation {
  id: string = null;
  email: string = null;
  firstName: string = null;
  lastName: string = null;
  role: string = null;
  status: string = null;

  @computed
  get accepted() {
    return this.status == 'accepted';
  }
}
